export default "__VITE_ASSET__B2b0Obgc__"